const initialState = {
	data: [],
	total: 0,
	params: {},
	selectedSportsbookType: {},
	sidebarOpen: false,
	sidebarStatus: 'add',
}

const sportsbooktype = (state = initialState, action) => {
	switch (action.type) {
		case 'SPORTSBOOKTYPE_GET_DATA':
			return {
				...state,
				data: action.data,
				total: action.total,
				params: action.params,
			}
		case 'SPORTSBOOKTYPE_ADD_DATA':
			return {
				...state,
				data: [...state.data, action.data],
				total: state.total + 1,
			}
		case 'SPORTSBOOKTYPE_UPDATE_DATA':
			return {
				...state,
				data: state.data.map((item) => (item.id === action.index ? action.data : item)),
			}
		case 'SPORTSBOOKTYPE_DEL_DATA':
			return {
				...state,
				data: state.data.filter((item) => item.id !== action.index),
				total: state.total - 1,
			}
		case 'SPORTSBOOKTYPE_GET_CURRENT':
			return {
				...state,
				selectedSportsbookType: action.selectedSportsbookType,
			}
		case 'SPORTSBOOKTYPE_SET_SIDEBAR':
			return {
				...state,
				sidebarStatus: action.status,
				sidebarOpen: !state.sidebarOpen,
			}
		default:
			return state
	}
}

export default sportsbooktype
